(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['followForm.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var stack1;
  if (stack1 = helpers.followChallengeId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.followChallengeId); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  return escapeExpression(stack1);
  }

function program3(depth0,data) {
  
  var stack1;
  if (stack1 = helpers.followTeacherId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.followTeacherId); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  return escapeExpression(stack1);
  }

function program5(depth0,data) {
  
  var stack1;
  if (stack1 = helpers.followSchoolId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.followSchoolId); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  return escapeExpression(stack1);
  }

function program7(depth0,data) {
  
  var stack1;
  if (stack1 = helpers.followURL) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.followURL); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  return escapeExpression(stack1);
  }

function program9(depth0,data) {
  
  var stack1;
  if (stack1 = helpers.followAbout) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.followAbout); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  return escapeExpression(stack1);
  }

  buffer += "<!-- FOLLOW FORM -->\n<div id=\"followEmailHolder\">\n    <div id=\"followEmail\">\n		<a href=\"#\" class=\"js-follow-email-close\">\n			<svg class=\"icon icon-delete\"><use xlink:href=\"/images/icon/icon-junior.svg#icon-delete\"></use></svg>\n		</a>\n		<form class=\"form-redux\" name=\"followEmailForm\" id=\"followEmailForm\" method=\"post\" action=\"";
  if (stack1 = helpers.secureBaseURL) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.secureBaseURL); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "common/mmi_update.html\" target=\"followIframe\">\n			<input type=\"hidden\" name=\"callback\" value=\"followStatus\" />\n			<input type=\"hidden\" name=\"postMessage\" value=\"parent.postMessage\" />\n\n			<input type=\"hidden\" name=\"challengeId\" value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.followChallengeId), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n			<input type=\"hidden\" name=\"teacherId\" value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.followTeacherId), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n			<input type=\"hidden\" name=\"schoolId\" value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.followSchoolId), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n			<input type=\"hidden\" name=\"searchURL\" value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.followURL), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n			<input type=\"hidden\" name=\"followAbout\" value=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.followAbout), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" />\n			<input type=\"hidden\" name=\"remove\" value=\"false\" />\n\n			<input type=\"hidden\" name=\"id\" value=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.bestQueryStringParam || (depth0 && depth0.bestQueryStringParam)),stack1 ? stack1.call(depth0, "id", "donorId", options) : helperMissing.call(depth0, "bestQueryStringParam", "id", "donorId", options)))
    + "\" />\n			<input type=\"hidden\" name=\"verify\" value=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.queryStringParam || (depth0 && depth0.queryStringParam)),stack1 ? stack1.call(depth0, "verify", options) : helperMissing.call(depth0, "queryStringParam", "verify", options)))
    + "\" />\n\n			<label for=\"followEmailInput\" id=\"followEmailMessage\">Save your Favorites:</label>\n			<div class=\"input-holder\">\n				<input id=\"followEmailInput\" type=\"email\" name=\"email\" disabled  autocomplete=\"off\" />\n				<input class=\"button-secondary small js-follow-email-submit\" type=\"submit\" name=\"followSubmit\" value=\"submit\" />\n			</div>\n		</form>\n    </div>  \n</div>\n";
  return buffer;
  });
})();